import DefaultPic from "images/cscec3b/shop/store-login-pic"
import DefaultPicW from "images/cscec3b/shop/store-login-picw"
import { DeviceContext, UserContext } from "libs/contexts"
import { webps } from "libs/imgs"
import { ProfilePageData } from "libs/profile-repo"
import { useRouter } from "next/router"
import { useContext, useEffect, useState } from "react"

webps[DefaultPic] = DefaultPicW

export default function ProfileMaskH5({ hasLogin }: ProfilePageData) {
  const router = useRouter()
  const inIframe: boolean = !!router.query.inIframe
  const [returnUrl, setReturnUrl] = useState("")
  const userinfo = useContext(UserContext)
  const { buildImgSrc } = useContext(DeviceContext)

  useEffect(() => {
    const href = inIframe
      ? window?.parent?.location?.href || "/"
      : window.location.href
    setReturnUrl(encodeURIComponent(href))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="mask-wrap">
      <div className="mask">
        {hasLogin ? (
          <div>
            <div className="mask-txt">认证后查看信息</div>
            {/* <a
              className="mask-btn"
              href={
                userinfo?.isPurchaser
                  ? "/portal/purchaser/purchaser/profile?type=credential"
                  : "/portal/supplier/supplier/profile/detail?type=credential"
              }
              target="_parent"
            >
              去认证
            </a> */}
          </div>
        ) : (
          <div>
            <div className="mask-txt">登录后查看信息</div>
            <a
              className="mask-btn"
              href={`/sso/login?return_url=${returnUrl}&role=purcharser`}
              target="_parent"
            >
              去登录
            </a>
          </div>
        )}
      </div>
      <style jsx>{`
        .mask-wrap {
          margin: -10px -10px 0 -10px;
        }
        .mask {
          width: 100%;
          height: 498px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-image: url(${buildImgSrc(DefaultPic)});
          background-size: 100% 498px;
          background-repeat: no-repeat;
        }
        .mask-txt {
          font-size: 14px;
          color: #333333;
          line-height: 1;
          margin-bottom: 12px;
        }
        .mask-btn {
          display: inline-block;
          height: 32px;
          width: 100px;
          border-radius: 4px;
          background-color: var(--primaryColor);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #ffffff;
          font-weight: bold;
        }
      `}</style>
    </div>
  )
}
